<div class="associations-container dark-mode mt-3">
    <div class="page-header">
        <div class="d-flex">
            <h1 class="page-title">Support Inbox</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Inbox</span>
        </div>
    </div>

    <hr class="mb-4" />
    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">Ticket ID</th>
                <th class="text-nowrap">Date</th>
                <th class="text-nowrap">Email</th>
                <th class="text-nowrap">Subject</th>
                <th class="text-nowrap">Status</th>
                <th class="text-nowrap">Last Update</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let msg of messages">
                <td class="text-nowrap" >#{{ msg.id }}</td>
                <td class="text-nowrap">{{ msg.openAt | date : "MM/dd/y hh:mm:ss" }}
                </td>
                <td class="text-nowrap" >{{ msg.email }}</td>
                <td  class="ellipsis" >{{ msg.messageSubject }}</td>
                <td class="text-nowrap" >
                    <mat-chip *ngIf="msg.status == 'OPEN'" style="background:#F0E7BE;">
                        {{maskingColumn('parameterLabel', 'parameterValue', ticketStatus.parameterMembers, msg.status)}}
                    </mat-chip>
                    <mat-chip *ngIf="msg.status == 'CLOSED'" style="background: #BEF0CA">
                        {{maskingColumn('parameterLabel', 'parameterValue', ticketStatus.parameterMembers, msg.status)}}
                    </mat-chip>
                </td>
                <td class="text-nowrap">{{ date.timeAgo(msg.updatedAt) }}
                </td>
                <td class="sticky-action">
                    <button (click)="conversation(msg.id)"
                            class="bg-accent-orange" mat-raised-button
                            aria-label="view message">
                        View Message
                    </button>
                </td>
            </tr>
            <tr *ngIf="messages.length == 0">
                <td colspan="7" class="text-center">
                    <span>No Record</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-4" *ngIf="messages.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>


